export default __webpack_public_path__ + "static/media/ultranewbg.f6b072fb.jpg";